"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var styles_scss_1 = tslib_1.__importDefault(require("./styles.scss"));
var Title = function (_a) {
    var text = _a.text;
    return (react_1.default.createElement("div", { className: styles_scss_1.default.title, "data-hook": "share-title" }, text));
};
Title.propTypes = {
    text: prop_types_1.default.string,
};
exports.default = Title;
//# sourceMappingURL=title.js.map